import React, { memo } from 'react';
import { string, object } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';
import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './AutosuggestEmpty.module.scss';
const cx = classNames.bind(styles);

const AutosuggestEmpty = ({ className, searchValue, labels }) => (
  <div className={cx('root', className)}>
    {labels.autosuggestionNoResults}
    <br />
    {labels.autosuggestionNoResultsFor} ‘{searchValue}’
  </div>
);

AutosuggestEmpty.propTypes = {
  searchValue: string.isRequired,
  labels: object.isRequired,
  className: string,
};

AutosuggestEmpty.defaultProps = {
  className: null,
};

export default memo(withLabels(withErrorBoundary(AutosuggestEmpty)));



// WEBPACK FOOTER //
// ./src/components/AutosuggestEmpty/AutosuggestEmpty.js